import lodash from 'lodash';
import { divideNumber } from './decimal';
export var isPublishOnline = function isPublishOnline() {
  return process.env['NX_CUSTOM_ENV'] === 'production';
};
export var isPublishStaging = function isPublishStaging() {
  return process.env['NX_CUSTOM_ENV'] === 'staging';
};
export var isPublishSandbox = function isPublishSandbox() {
  return process.env['NX_CUSTOM_ENV'] === 'sandbox';
}; // _ -> UpperCase

function convertToCamelCase(str) {
  return str.replace(/_([a-z])/g, function (match, group1) {
    return group1.toUpperCase();
  });
} // UpperCase -> _


function convertToHumpNaming(str) {
  if (!str) return '';
  return lodash.split(str, /(?=[A-Z])/).join('_').toLowerCase();
}

var isObjectNotArrayOrNumber = function isObjectNotArrayOrNumber(data) {
  return lodash.isPlainObject(data) && !Array.isArray(data) && typeof data !== 'number';
}; // underline naming -> hump naming, only one layer


export var covertFromUnderlineToHumpObject = function covertFromUnderlineToHumpObject(data) {
  if (!isObjectNotArrayOrNumber(data)) return data;
  return lodash.mapKeys(data, function (value, key) {
    return convertToCamelCase(key);
  });
}; // hump naming -> underline naming, only one layer

export var covertFromHumpToUnderlineObj = function covertFromHumpToUnderlineObj(data) {
  if (!isObjectNotArrayOrNumber(data)) return data;
  return lodash.mapKeys(data, function (value, key) {
    return convertToHumpNaming(key);
  });
}; // get label by value

export var getListItemLabelByValue = function getListItemLabelByValue(list, value) {
  var keyMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    labelKey: 'label',
    valueKey: 'value'
  };
  if (!lodash.isArray(list)) return '';
  var temp = list.find(function (item) {
    return item[keyMap.valueKey] === value;
  });
  return temp ? temp[keyMap.labelKey] : '';
}; // get value by label

export var getListItemValueByLabel = function getListItemValueByLabel(list, label) {
  var keyMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    labelKey: 'label',
    valueKey: 'value'
  };
  if (!lodash.isArray(list)) return '';
  var temp = list.find(function (item) {
    return item[keyMap.labelKey] === label;
  });
  return temp ? temp[keyMap.valueKey] : '';
}; // get list item by value

export var getListItemByValue = function getListItemByValue(list, value) {
  var keyMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    labelKey: 'label',
    valueKey: 'value'
  };
  if (!lodash.isArray(list)) return undefined;
  return list.find(function (item) {
    return item[keyMap.valueKey] === value;
  });
};
export var convertBytes = function convertBytes(bytes, config) {
  if (!bytes) {
    return {
      KB: 0,
      MB: 0,
      GB: 0
    };
  }

  var _ref = config || {},
      _ref$fixLength = _ref.fixLength,
      fixLength = _ref$fixLength === void 0 ? 2 : _ref$fixLength;

  var KB = bytes / 1024; // 1KB = 1024 B

  var MB = bytes / (1024 * 1024); // 1 MB = 1024^2 B

  var GB = bytes / (1024 * 1024 * 1024); // 1 GB = 1024^3 B

  return {
    KB: Number(KB.toFixed(fixLength)),
    MB: Number(MB.toFixed(fixLength)),
    GB: Number(GB.toFixed(fixLength))
  };
};
export var capitalizeAllWords = function capitalizeAllWords(str, config) {
  if (!str) return str;
  var words = str.split(' ');
  var capitalizedWords = [];

  if (config !== null && config !== void 0 && config.allUpperCase) {
    capitalizedWords = lodash.map(words, function (word) {
      return word.toUpperCase();
    });
  } else {
    capitalizedWords = lodash.map(words, lodash.capitalize);
  }

  var newValue = capitalizedWords.join(' ');
  return newValue;
};
export var convertNumberToPercentage = function convertNumberToPercentage(data, fields) {
  if (!data) return data;
  fields.forEach(function (key) {
    data[key] = divideNumber(data[key], 100);
  });
};